import styles from './states.module.css';

/**
 * Errors are actionable and never colour-only: an icon, a sentence, and a way out
 * (skill 13.3, 16).
 */
export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className={styles.state} role="alert">
      <span className={styles.icon} aria-hidden="true">
        ⚠️
      </span>
      <p className={styles.title}>Không tải được dữ liệu</p>
      <p className={styles.message}>{message}</p>
      {onRetry ? (
        <button type="button" className={styles.action} onClick={onRetry}>
          Thử lại
        </button>
      ) : null}
    </div>
  );
}
